//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The order state to show in clients.
*
* 
*  * INITIAL value: INITIAL - The initial value. Used for new orders. 
*  * PROCESSING value: PROCESSING - Order processing: to be set by order approve. 
*  * SHIPPED value: SHIPPED - Order shipped: order is in shipment. 
*  * COMPLETED value: COMPLETED - Order completed: delivered and payment completed 
*  * CANCELLED value: CANCELLED - Order cancelled. 
*  * REVERSAL value: REVERSAL - Order reversal (Rückabwicklung). 
*/
@Serializable
enum class OrderState(val value: kotlin.String) {

    @SerialName(value = "INITIAL")
    INITIAL("INITIAL"),

    @SerialName(value = "PROCESSING")
    PROCESSING("PROCESSING"),

    @SerialName(value = "SHIPPED")
    SHIPPED("SHIPPED"),

    @SerialName(value = "COMPLETED")
    COMPLETED("COMPLETED"),

    @SerialName(value = "CANCELLED")
    CANCELLED("CANCELLED"),

    @SerialName(value = "REVERSAL")
    REVERSAL("REVERSAL");

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is OrderState) "$data" else null

    /**
    * Returns a valid [OrderState] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): OrderState? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

